import React from 'react';

import { EtatRequestDtoEtatEnum } from 'lib_api/lib/api/gen';

import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { FormInputProps } from 'components/BaseForm/types';

import BaseModalEdition from '../../Modals/ModalEdition/ModalEdition';
import { EtatFormField, EtatFormValue } from '../types';

interface ModalEditionProps {
  close: () => void;
  visible: boolean;
  initials: EtatFormValue;
  title: string;
  submit: (values: EtatFormValue) => void;
  isSubmitting: boolean;
  validate: (field: EtatFormField, values: EtatFormValue) => Promise<void>;
}

function ModalEdition({ ...props }: ModalEditionProps): React.ReactElement {
  const inputs: Array<FormInputProps<EtatFormValue, EtatFormField>> = [
    {
      name: 'etat',
      label: 'Etat',
      field: 'ETAT',
      required: true,
      render: () => {
        return (
          <BaseSelect
            options={Object.keys(EtatRequestDtoEtatEnum)}
            getOptionValue={option => option}
            getOptionLabel={option => option}
          />
        );
      },
    },
    {
      name: 'detail',
      label: 'Detail',
      field: 'DETAIL',
    },
    {
      name: 'libelleCourt',
      label: 'Libellé',
      field: 'LIBELLE_COURT',
    },
  ];

  return <BaseModalEdition {...props} inputs={inputs} />;
}

export default ModalEdition;
